import {Component} from '@angular/core';
import {WebstoreUsersPage} from '../webstore-users/webstore-users';
import { UsersPage } from '../users/users';
import {GVLogger} from "../../services/gv-logger";
@Component({
  selector: 'user-management-tabs',
  templateUrl: 'user-management-tabs.html'
})
export class UserManagementTabsPage {

  tab1Root = WebstoreUsersPage;
  tab2Root = UsersPage;

  constructor(private gVLogger: GVLogger) {
  }


}



// WEBPACK FOOTER //
// ./src/pages/user-management-tabs/user-management-tabs.ts